export class BiomarkerQuantitativeData {
  private biomarkerName: string;
  private data: number[] | number[][];
  private sliceIndex: string;

  constructor(
    biomarkerName: string,
    data: number[] | number[][],
    sliceIndex: string,
  ) {
    this.biomarkerName = biomarkerName;
    this.data = data;
    this.sliceIndex = sliceIndex;
  }

  public getBiomarkerName(): string {
    return this.biomarkerName;
  }

  public getData(): number[] | number[][] {
    return this.data;
  }

  public getSliceIndex(): string {
    return this.sliceIndex;
  }
}
